<template lang="pug">
el-dialog(title='Talent追加', :visible.sync='visible', width='90%', :before-close='hideModal')
  el-table.c-table(:data='talent' style='width: 100%')
    el-table-column(prop='profile_image' label='' width='120')
      template(slot-scope='scope')
        template(v-if='scope.row.profile_image')
          img.c-thumb__item--1-1(:src='scope.row.profile_image.uri')
        template(v-else)
          .c-thumb__item--1-1
            p no image
    el-table-column(prop='name.ja', label='Name')
    el-table-column(prop='title.ja', label='Title')
    el-table-column(prop='status', label='Status', width='100')
      template(slot-scope='scope')
        el-tag(:type="scope.row.status === 1 ? 'success' : 'info'") {{status(scope.row.status)}}
    el-table-column(label='', width='100')
      template(slot-scope='scope')
        el-button(size='mini' type='primary' @click='hideModal(scope.row)' icon='el-icon-plus') 追加
  span.dialog-footer(slot='footer')
    el-button(@click='hideModal') 閉じる
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default { name: 'ElementModalAddTalentElement',
  data () {
    return {}
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    init () {
      /**
       * 表示用のデータを取得する
       */
      this.getTalent()
    },
    /**
     * モーダルを閉じる
     */
    hideModal (data) {
      this.$emit('hideModal', data)
    },
    status (data) {
      return (data === 1) ? '公開' : '非公開'
    },
    ...mapActions([
      'getTalent'
    ])
  },
  computed: {
    ...mapGetters([
      'OPTIONS',
      'LOADING',
      'talent'
    ])
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Modal/AddTalentElement/index.vue